import React, {useState, useEffect} from 'react';
import {useParams, useHistory} from 'react-router-dom';
import axios from 'axios';
import moment from 'moment';
import useNotif from 'hooks/use-notify-hook';
import {useAlert, TYPES} from 'hooks/use-alert-hook.js';
import {useLocalStorage} from 'react-use';
import AnswerActionContext from '../Utils/context.js';
import AnswerActionEdit from '../Edit.js';
import ReactDatetime from "react-datetime";
import {
  Button,
  Col,
  Form,
  Row,
  Modal,
} from 'react-bootstrap';

export default function Edit() {

  const history = useHistory();
  const {actionId, employeeId} = useParams();
  const [notif, dispatchNotif] = useNotif();
  const [swal, setSwal] = useAlert(null);
  const [auth] = useLocalStorage('authenticated');
  const [completedAt, setCompletedAt] = useState(null);
  const [isVisible, setIsVisible] = useState(false)
  const [cause, setCause] = useState('');

  const handleCompletedAt = async (value, id) => {

    const prettyDate = value.format('YYYY-MM-DD');

    try {

      const response = await axios.put(
        `${process.env.REACT_APP_API_HOST}answer-actions/${id}`,
        {COMPLETED_AT: prettyDate},
        {headers: {Authorization: `Bearer ${auth.token}`}},
      );

      setCompletedAt(prettyDate);

      dispatchNotif({
        place: `br`,
        message: `Update Success...`,
        type: `success`,
      });

    } catch (error) {
      console.error(error);
      alert('error');
    }
  }

  const handleSubmit = async (scheduleId, status) => {

    try {

      const onSuccessCallback = async () => {

        let payload = {ANSWER_ACTION_STATUS: status};
        if (status === `OPEN`) payload.COMPLETED_AT = null;


        const response = await axios.put(
          `${process.env.REACT_APP_API_HOST}answer-actions/${actionId}`,
          payload,
          {headers: {Authorization: `Bearer ${auth.token}`}},
        );

        history.push(`/admin/audits/${scheduleId}/findings`);

      }

      setSwal({
        type: TYPES.CONFIRM,
        payload: {
          title: `Are you sure!`,
          message: `You won't be able to edit it again.`,
          onSuccess: {
            title: `Success`,
            message: `Submit Success`,
            callback: onSuccessCallback,
          }
        }
      });

    } catch (error) {
      console.log(error);
      setSwal({
        type: TYPES.ERROR,
        payload: {
          message: error.toString(),
        }
      });
    }
  }

  const handleReject = async(addExp) =>{

    try {

      setCause(addExp);
      setIsVisible(true);
      dispatchNotif({
        place: `bc`,
        message: `You pressed action reject, please fill in the additional comments column and SAVE ...`,
        type: `danger`,
      });
    } catch (error) {
      console.log(error);
      setSwal({
        type: TYPES.ERROR,
        payload: {
          message: error.toString(),
        }
      });
    }
  }

  const handleRejectExp = async (value, id, scheduleId, status) => {

    const valueExp = value;

    try {

      const onSuccessCallback = async () => {
        let payload = {ANSWER_ACTION_STATUS: status,REJECT_EXPLAIN: valueExp};
        if (status === `OPEN`) payload.COMPLETED_AT = null;

        const response = await axios.put(
          `${process.env.REACT_APP_API_HOST}answer-actions/${id}`,
          payload,
          {headers: {Authorization: `Bearer ${auth.token}`}},
        );

        history.push(`/admin/audits/${scheduleId}/findings`);

      }

      setSwal({
        type: TYPES.CONFIRM,
        payload: {
          title: `Are you sure to!`,
          message: `You won't be able to edit it again.`,
          onSuccess: {
            title: `Success`,
            message: `Submit Success`,
            callback: onSuccessCallback,
          }
        }
      });
      // history.push(`/admin/actions/${id}/edit`);
      // history.push(`/admin/audits/${scheduleId}/findings`);

    } catch (error) {
      console.error(error);
      alert('error');
    }
  }

  return (
    <AnswerActionEdit>
      {swal}{notif}
      <AnswerActionContext.Consumer>
        {({answerAction, attachments}) => {
          return (
            <Row>
              <Col md="8">
                <Form.Group>
                  <Form.Label>{answerAction?.actionType?.ACTION_TYPE_NAME}</Form.Label>
                  <p>{answerAction.ACTION_DESC || <span className="text-danger">Not answered yet.</span>}</p>
                </Form.Group>
                {answerAction?.REJECT_EXPLAIN !== null && answerAction?.ANSWER_ACTION_STATUS === 'OPEN' &&(
                    <Form.Group>
                      <Form.Label>comments for rejection</Form.Label>
                      <p>{answerAction?.REJECT_EXPLAIN ?? `N/A`}</p>
                    </Form.Group>
                )}
                {answerAction?.ANSWER_ACTION_STATUS === 'IN PROGRESS' && (
                  <Form.Group>
                    <Form.Label>Completed At</Form.Label>
                    <ReactDatetime
                      value={completedAt ?? answerAction?.COMPLETED_AT ? moment(answerAction.COMPLETED_AT).format('YYYY-MM-DD') : ``}
                      inputProps={{
                        className: "form-control",
                        placeholder: "Date Picker Here",
                      }}
                      onChange={value => handleCompletedAt(value, answerAction.ANSWER_ACTION_ID)}
                      timeFormat={false}
                    />
                  </Form.Group>
                )}

                {answerAction?.ANSWER_ACTION_STATUS === 'COMPLETED' && (
                  <Form.Group>
                    <Form.Label>Completed At</Form.Label>
                    <p>{moment(answerAction.COMPLETED_AT, 'DD-MMM-YYYY').format('DD-MM-YYYY')}</p>
                  </Form.Group>
                )}

                {answerAction?.ANSWER_ACTION_STATUS === 'IN PROGRESS' && (
                  <Form.Group>
                    <Button variant="success" onClick={() => handleSubmit(answerAction?.answer?.form?.SCHEDULE_ID, `COMPLETED`)}>Approve</Button>{' '}
                    <Button variant="danger" onClick={() => handleReject(answerAction?.REJECT_EXPLAIN)}>Reject</Button>
                  </Form.Group>
                )}
                <div style={{ display: isVisible ? "block" : "none" }}>
                  <Form.Group>
                    <Form.Label>comments for rejection</Form.Label>
                    <Form.Control
                      value={cause}
                      onChange={({ target: { value }}) => setCause(value)}
                      as="textarea"
                      rows={3}
                      isInvalid={cause?.length > 4000}
                    />
                    <Form.Text id="passwordHelpBlock" muted>
                      Total characters: {cause?.length ?? 0} / 4000
                    </Form.Text>
                    <Button variant="danger" onClick={() => handleRejectExp(cause, answerAction.ANSWER_ACTION_ID, answerAction.answer.form.SCHEDULE_ID,`OPEN`)}>Save</Button>
                  </Form.Group>
                </div>
              </Col>
              <Col md="4">
                <Form.Group>
                  {attachments
                    ? attachments.map((attachment, key) => (
                      <div key={key} className="font-icon-detail">
                        <a href={`${process.env.REACT_APP_API_HOST}answer-action-attachments/${attachment.ANSWER_ACTION_ATTACHMENT_ID}/download`}>
                          {attachment.ATTACHMENT_NAME}.{attachment.ATTACHMENT_EXT}
                        </a>
                      </div>
                    ))
                    : <p>No file uploaded.</p>
                  }
                </Form.Group>
              </Col>
            </Row>
          )
        }}
      </AnswerActionContext.Consumer>
    </AnswerActionEdit>
  )
}